import { AnimatePresence } from "framer-motion";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useParams } from "react-router-dom";

import { H1 } from "../base";
import { ExplorerBillboard, MainBillboard } from "../components/BillBoard";

const Home = () => {
  const { type: slugType, slug } = useParams<{ type: string; slug: string }>();

  return (
    <>
      <ErrorBoundary fallback={<H1>There&apos;s been a problem</H1>}>
        <AnimatePresence mode="wait">
          {!slug ? (
            <MainBillboard />
          ) : (
            <ExplorerBillboard key={slug} slug={slug} slugType={slugType} />
          )}
        </AnimatePresence>
      </ErrorBoundary>
    </>
  );
};

export default Home;
